export default "__VITE_ASSET__e$83g$d9__"